import { Detail } from "../types/inspection";
import { PointType } from "../types/workOrder";

export const isPointCompleted = (
  detail: Detail,
  itemType?: number
): boolean => {
  if (
    itemType === 2 &&
    [PointType.Year, PointType.Make, PointType.Model].includes(
      detail.verifyField_ID
    )
  ) {
    return true;
  }

  if (detail.notApplicable) {
    return true;
  } else if ([4, 5].includes(detail.type_ID)) {
    return !!detail.answerValue;
  } else if ([1, 3].includes(detail.type_ID)) {
    return !!detail.answerValue;
  } else {
    return detail.photos && detail.photos.length > 0;
  }
};

export const MAX_LIMIT_EDIT_ICON = 250;
export const MAX_LIMIT_EDIT_ICON_VERIFY_ID_TWO_THREE = 50;
export const MAX_LIMIT_64 = 64;
export const MAX_LIMIT_128 = 128;
export const LIMIT_EXCEED_ERROR_EDIT_ICON =
  "Your input exceeds the 250 character limit";
export const LIMIT_EXCEED_ERROR_EDIT_ICON_VERIFY_ID_TWO_THREE =
  "Your input exceeds the 50 character limit"
export const LIMIT_EXCEED_ERROR_64 =
  "Your input exceeds the 64 character limit.";
export const LIMIT_EXCEED_ERROR_128 =
  "Your input exceeds the 128 character limit.";
